import { useContext, useEffect, useRef } from "react";
import { useFirebase } from "../Firebase";
import { useNavigateCompat } from "../../helpFunctions/hooks";
import { DataStoreContext } from "./DataStoreContext";

const ACTIVITY_EVENTS = ["pointerdown", "keydown", "scroll", "touchstart"];

const InactivityLogout = ({ authUser }) => {
  const { state } = useContext(DataStoreContext);
  const firebase = useFirebase();
  const navigate = useNavigateCompat();
  const timeoutRef = useRef(null);
  const signingOutRef = useRef(false);

  useEffect(() => {
    signingOutRef.current = false;
  }, [authUser?.userId]);

  useEffect(() => {
    const inactivityLogoutMinutes = Number(state.settings?.inactivityLogoutMinutes);

    if (typeof window === "undefined" || !authUser?.userId || !Number.isFinite(inactivityLogoutMinutes) || inactivityLogoutMinutes <= 0) {
      return;
    }

    const timeoutMs = inactivityLogoutMinutes * 60 * 1000;

    const resetTimer = () => {
      if (signingOutRef.current) return;

      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        if (signingOutRef.current) return;

        signingOutRef.current = true;
        firebase.signOut(navigate);
      }, timeoutMs);
    };

    ACTIVITY_EVENTS.forEach(eventName => {
      window.addEventListener(eventName, resetTimer);
    });

    resetTimer();

    return () => {
      window.clearTimeout(timeoutRef.current);
      ACTIVITY_EVENTS.forEach(eventName => {
        window.removeEventListener(eventName, resetTimer);
      });
    };
  }, [authUser?.userId, firebase, navigate, state.settings?.inactivityLogoutMinutes]);

  return null;
};

export default InactivityLogout;
